<template>
    <div v-if="bizAuth.settingContract.hasRight" class="page-setting has-bc biz-contract-setting-default parent-frame" :class="{'fixed': listIsFixed}">
        <div class="tool-bar-mask"></div>
        <div class="page-header">
            <h1>{{$route.meta.title}}</h1>
            <div class="btn-group">
                <button class="new-item-btn preview" @click="previewContractVersion('CHARTER')">
                    <img src="@/assets/img/icon/view_gray.svg" alt="" srcset="">
                    預覽包租合約
                </button>
                <button class="new-item-btn preview" @click="previewContractVersion('ESCROW')">
                    <img src="@/assets/img/icon/view_gray.svg" alt="" srcset="">
                    預覽代管合約
                </button>
                <button class="default-button insert" @click="save">儲存</button>
            </div>
        </div>
        <contract-setting-comp :submit="submitEnt" :preview="previewEnt" :type="type"></contract-setting-comp>
    </div>
</template>
<script>
import contractSettingComp from '@/components/bussiness/settingCenter/contractSetting/contractSettingComp.vue';
import { mapGetters } from 'vuex'

export default {
    data () {
        return {
            listIsFixed: false,
            submitEnt: 0,
            previewEnt: 0,
            type: null
        }
    },
    mounted () {
        this.$analyticsBiz.logEvent(this.$route.meta.title, { screen_name: this.$route.meta.title})
        window.addEventListener('scroll', this.handleScroll);
    },
    destroyed() {
        window.removeEventListener('scroll', this.handleScroll);
        document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
    },
    watch: {
        'bizAuth.settingContract.hasRight': function (val) {
            if(!val){
                this.$store.dispatch('setModalStatus', {state: true, type: 'bizNoRight'})
            }
        }
    },
    methods: {
        handleScroll: function () {
            let scrollTop = event.target.documentElement.scrollTop
            // console.log(scrollTop)
            if( scrollTop >= 50){
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'none'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
            }else{
                document.getElementsByClassName('biz-tool-bar-wrap')[0].style.display = 'flex'
                document.getElementsByClassName('parent-frame')[0].style.zIndex = '7'
                this.listIsFixed = false
            }

            if( scrollTop >= 115){
                this.listIsFixed = true
            }
        },
        preview: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.previewEnt += 1
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        save: function () {
            if(this.verifiedStatus === 'NORMAL'){
                this.submitEnt += 1
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        },
        previewContractVersion: function (type) {
            if(this.verifiedStatus === 'NORMAL'){
                this.type = type
                this.previewEnt += 1
            }else{
                this.$store.dispatch('bizSetVerifiedAlarmBling', 200)
            }
        }
    },
    components: {
        contractSettingComp
    },
    computed: {
        ...mapGetters({
            verifiedStatus: 'GET_BIZ_COMPANY_IS_VERIFIED',
            bizAuth: 'GET_BIZ_AUTH',
        })
    },
}
</script>
<style lang="scss">
    .biz-contract-setting-default{
        position: relative;
        margin-top: 100px;
        .page-header{
            .btn-group{
                .insert{
                    width: 120px;
                    height: 44px;
                    // padding: 11px 0px;
                    border-radius: 4px;
                }
                .preview{
                    width: 146px;
                    margin-right: 10px;
                }
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/pages/bussiness/settingCenter/contractSetting/contractSettingDefault.vue